import styled, { css } from 'styled-components'
import React from 'react'

import { Noto_body1_b16, Noto_desc_m10, Noto_desc_r10 } from 'src/styles/fonts/NotoSansKrFonts'
import Marquee from 'react-fast-marquee'
import { bottomOutPageTransitionProps } from 'src/styles/animation'
import { Container } from 'src/components/common/Container'
import { mediaMaxWidth, ZIndex } from 'src/styles/mixin'
import gs_logo from 'src/assets/images/preview/preview_gs25_logo.png'
import { Typography } from 'src/components/common/Typography'
import coupon_bg from 'src/assets/images/preview/preview_coupon.gif'
import { PreviewPageProps } from 'src/pages/PreviewPage'
import { click_tracking_dataLayer } from 'src/utils/gtmDataLayer'

const PreviewBottomSheet = (props: PreviewPageProps) => {
  const { handleExternalOpenUrl } = props

  const handleClickBottomSheet = () => {
    click_tracking_dataLayer('bottom_floating')
    handleExternalOpenUrl('free_coupon')
  }

  return (
    <Container
      $option="flex_row_space_between"
      $style={S.PreviewBottomSheetContainer}
      $column_gap="10px"
      {...bottomOutPageTransitionProps}
      onClick={handleClickBottomSheet}
    >
      <Container $option="flex_column" $row_gap="2px" $style={S.PreviewBottomSheetContents}>
        <S.Chips>
          <S.ChipsBottom />
          2매 증정
        </S.Chips>
        <S.MarqueeContents $option="flex_row" $column_gap="7px">
          <S.LogoImage src={gs_logo} alt="GS25" />
          <Typography $fontStyle={Noto_body1_b16} $color="var(--white)">
            금액권 1,000원
          </Typography>
        </S.MarqueeContents>
      </Container>
      <S.CouponImage src={coupon_bg} alt="coupon" />
      <S.AdNoti>AD</S.AdNoti>
      <S.PaidNoti>휴대폰쿠폰지갑 유료서비스 광고</S.PaidNoti>
    </Container>
  )
}

export default PreviewBottomSheet

const S = {
  PreviewBottomSheetContainer: css`
    position: fixed;
    bottom: 16px;
    flex-flow: row nowrap;
    align-items: flex-end;
    width: calc(100% - 20px);
    background-color: var(--black-90);
    border-radius: 12px;
    padding: 15px 15px 22px 14px;
    z-index: ${ZIndex.BottomSheet};
    max-width: 500px;
    min-width: 280px;
    cursor: pointer;
  `,
  PreviewBottomSheetContents: css`
    height: 47px;
    min-width: 0;

    ${mediaMaxWidth('320')} {
      height: 44px;
    }
  `,
  Chips: styled.section`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 4px;
    width: 48px;
    color: var(--white);
    background-color: #00a4fc;
    border-radius: 100px;
    ${Noto_desc_m10};
  `,
  ChipsBottom: styled.div`
    position: absolute;
    bottom: -1px;
    left: 18px;
    width: 12px;
    height: 12px;
    background-color: #00a4fc;
    transform: rotate(45deg);
    z-index: -1;
  `,
  PrimaryMarquee: styled(Marquee)`
    overflow: hidden;
  `,
  MarqueeContents: styled(Container)`
    display: flex;
    align-items: center;
    gap: 7px;
  `,
  LogoImage: styled.img`
    margin-top: 2px;
    width: auto;
    height: 12px;
  `,
  CouponImage: styled.img`
    height: 58px;
    width: auto;

    ${mediaMaxWidth('320')} {
      height: 48px;
      width: auto;
    }
  `,
  AdNoti: styled.span`
    ${Noto_desc_r10};
    position: absolute;
    left: 7px;
    top: 2px;
    color: var(--white);
  `,
  PaidNoti: styled.span`
    ${Noto_desc_r10};
    position: absolute;
    right: 7px;
    bottom: 2px;
    color: var(--white);
  `,
}
